<template>
  <div
    class="container"
    :class="{is_mirror: isMirror}"
  >
    <TicketCommon
      v-if="tempTicket"
      ref="tempTicket"
      :class="[showTempTicket ? 'show' : 'hide']"
      :ticket="tempTicket"
    />
    <div class="top">
      <div class="tickets" :style="{order: isMirror ? '1' : '0'}">
        <div
          v-for="(item, index) in currentItems.slice(0, 3)"
          :key="item ? item.id : -(index + 1)"
          class="infoscreen-item"
          :style="{
            borderColor: $store.infoscreenData.infoboardWindowColor,
            backgroundColor: $store.infoscreenData.infoboardBackgroundColor
          }"
        >
          <TicketCommon v-if="item" ref="ticket" :ticket="item" />
        </div>
      </div>
      <div class="frame">
        <PlaylistFrame :playlist="$store.deviceStartData.main_play_list" :playlist-type="'main'" />
      </div>
    </div>

    <div class="bottom">
      <template v-if="isAdditionalFrame">
        <div
          class="infoscreen-item"
          :style="{
            borderColor: $store.infoscreenData.infoboardWindowColor,
            backgroundColor: $store.infoscreenData.infoboardBackgroundColor
          }"
        >
          <TicketCommon v-if="currentItems[3]" ref="ticketFourth" :ticket="currentItems[3]" />
        </div>

        <div class="widget-wrapper">
          <PlaylistFrame
            :playlist="$store.deviceStartData.additional_play_list"
            :playlist-type="PLAYLIST_TYPE.ADDITIONAL"
            :style="{
              borderColor: $store.infoscreenData.infoboardWindowColor,
              backgroundColor: $store.infoscreenData.infoboardBackgroundColor
            }"
          />
        </div>
      </template>

      <template v-else>
        <div
          v-for="(item, index) in currentItems.slice(3)"
          :key="item ? item.id : -(index + 1)"
          class="infoscreen-item"
          :style="{
            borderColor: $store.infoscreenData.infoboardWindowColor,
            backgroundColor: $store.infoscreenData.infoboardBackgroundColor
          }"
        >
          <TicketCommon v-if="item" :ticket="item" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import TicketCommon from '../tickets/TicketCommon';
import PlaylistFrame from '../PlaylistFrame';
import TemplateMixin from '../../mixins/TemplateMixin';
import PLAYLIST_TYPE from '../../constants/PlaylistType';

export default {
  name: 'TemplateCommon',
  components: {
    TicketCommon,
    PlaylistFrame
  },
  mixins: [TemplateMixin],
  props: {
    isMirror: Boolean,
    isAdditionalFrame: Boolean
  },
  data() {
    return {
      PLAYLIST_TYPE: PLAYLIST_TYPE
    };
  },
  computed: {
    ticketsCount() {
      return this.isAdditionalFrame ? 4 : 7;
    },
    currentItems() {
      return this.getCurrentTickets(this.ticketsCount);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;

  &.is_mirror {
    .top .tickets .infoscreen-item {
      border-left-style: solid;
      border-right: 0;
    }

    .bottom {
      flex-flow: row-reverse;

      .infoscreen-item:not(:last-child) {
        border-left-style: solid;
        border-right: 0;
      }
    }
  }
}

.top {
  display: flex;
  height: 75%;

  .frame {
    flex-grow: 1;
    height: 100%;
    width: 75%;
  }

  .tickets {
    height: 100%;
    width: 25%;
    min-width: 25%;

    .infoscreen-item {
      height: 33.33333%;
      border-bottom-style: solid;
      border-right-style: solid;

      &__mirror {
        border-left-style: solid;
      }
    }
  }
}

.infoscreen-item {
  border-width: 4px;
  border-width: max(0.21vw, 4px);
}

.playlist-wrapper,
.widget {
  flex-grow: 1;
}

.widget-wrapper {
  width: 75%;
  height: 100%;
  overflow: hidden;
}

.bottom {
  display: flex;
  height: 25%;

  .infoscreen-item {
    height: 100%;
    width: 25%;
    min-width: 25%;

    &:not(:last-child) {
      border-right-style: solid;
    }
  }
}

.show {
  display: flex;
}

.hide {
  display: none;
}
</style>
